import { render, staticRenderFns } from "./InventoryLimitEditor.vue?vue&type=template&id=15974934"
import script from "./InventoryLimitEditor.vue?vue&type=script&lang=js"
export * from "./InventoryLimitEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports